import moment from 'moment';
import overviewEditMixin from './overviewEditMixin';
import SocketMixin from './socketMixin';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import set from 'lodash/set';
import isEmpty from 'lodash/isEmpty';
import { mapState } from 'vuex';
export default {
  mixins: [SocketMixin, overviewEditMixin],
  props: {
    dtwin: {
      type: Object,
      required: true,
    },
    baseLink: {
      type: String,
      required: false,
      default: 'digitaltwin-mgmt',
    },
    titleAttributePath: {
      type: String,
      required: false,
      default: 'title',
    },
  },
  data: function () {
    return {
      loading: false,
      updatedStates: [],
      showJSONdata: null,
      showJSONdialog: false,
    };
  },
  computed: {
    ...mapState('app', ['color']),

    showSkeletonLoader() {
      return get(this.dtwin, 'data', true) === true;
    },
    dtwinCoordinates() {
      return get(this.dtwin, 'coordinates.coordinates', [null, null]);
    },
    dtwinPolygon() {
      return get(this.dtwin, 'polygon.coordinates', []);
    },
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
  },
  watch: {
    dtwin(newV, oldV) {
      if (newV.id !== oldV.id) {
        this.twinDataStates = [];
        this.loadStates(this.dtwin);

        this.teardownDtwinSocket();
        this.setupDtwinSocket(this.dtwin.id);
      }
    },
  },
  mounted() {
    if (this.dtwin.id) {
      this.loadStates(this.dtwin);

      this.setupDtwinSocket(this.dtwin.id);
    }
  },

  methods: {
    isObjEmpty(tempObj) {
      return isEmpty(tempObj);
    },
    get,
    statesValuesUpdated(statesData) {
      statesData.forEach((stateData) => {
        const state = (this.twinDataStates || []).find((s) => parseInt(s.id) === parseInt(stateData.id));
        set(state, 'value', stateData);
      });
      this.updatedStates = statesData;
      this.twinDataStates = cloneDeep(this.twinDataStates);
    },
    didUpdateStates() {
      this.loadStates(this.dtwin);
    },
    showJSON(a) {
      this.showJSONdata = JSON.parse(a);
      this.showJSONdialog = true;
    },
    changeTwin(selected) {
      this.pushToRouter(`/${this.baseLink}/${selected.id}`);
    },
    pushToRouter(path, selected = null) {
      this.$router.push({
        path: path,
        query: { parent: selected ? selected.id : null, openTree: JSON.stringify(this.open) },
      });
    },
    localizeDate(a) {
      if (a) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
        return moment(a).format('L LTS');
      }
      return '-';
    },
  },
};
